import { render, staticRenderFns } from "./my_help.vue?vue&type=template&id=143084ec&scoped=true&"
import script from "./my_help.vue?vue&type=script&lang=js&"
export * from "./my_help.vue?vue&type=script&lang=js&"
import style0 from "./my_help.vue?vue&type=style&index=0&id=143084ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143084ec",
  null
  
)

export default component.exports